// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import qs from 'query-string';
import { Route, NavLink } from 'react-router-dom';
import { withRouter } from 'react-router';
import { Row, Col } from 'react-flexbox-grid';
import ProjectActions from '../actions/project.actions';
import { bindActionCreators } from 'redux';
import { getTranslate } from 'react-localize-redux';
import Input from 'react-toolbox/lib/input';
import Button from '../common/ButtonComp';

class TrafficFilterComp extends Component {
  state: {
    userAgentRegexFilter: string
  };
  constructor(props) {
    super(props);

    this.state = {
      userAgentRegexFilter: (props.project && props.project.userAgentRegexFilter) || ''
    };
  }

  saveSettings = () => {
    const {
      projectActions: { saveRegex },
      project
    } = this.props;

    saveRegex({ ...this.state, id: project._id });
  };

  handleChange = (name, value) => {
    this.setState({ [name]: value.trim() });
  };

  render() {
    const { translate } = this.props;
    const { userAgentRegexFilter } = this.state;

    return (
      <div className="content">
        <h1>{translate('filters.set_up')}</h1>
        <p>{translate('filters.set_up_description')}</p>
        <Input
          type="text"
          hint={translate('filters.enter_regex')}
          value={userAgentRegexFilter}
          onChange={this.handleChange.bind(this, 'userAgentRegexFilter')}
        />
        <Button big primary onClick={this.saveSettings.bind(this)}>
          {translate('app.save')}
        </Button>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const search = state.routing.location.search;
  const query = search ? qs.parse(search) : { idx: 0 };

  const { projects } = state.me.user;

  const project = query.projectId
    ? projects.find(({ _id }) => _id == query.projectId)
    : projects.find(({ index }) => index == query.idx);

  return {
    query,
    project,
    me: state.me,
    user: state.me && state.me.user,
    location: state.routing.location,
    translate: getTranslate(state.locale),
    wizard: state.wizard
  };
}

function mapDispatchToProps(dispatch) {
  return {
    projectActions: bindActionCreators(ProjectActions, dispatch)
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TrafficFilterComp));



// WEBPACK FOOTER //
// ./src/filters/TrafficFilterComp.js